import React, { useEffect, useState, useRef } from "react";
import RequestDocFormTemplate from "./RequestDocFormTemplate";
import {
    editRequestUpdateDocumentForm,
    getEnvelopeDocumentDetail,
    getEnvelopeRequestInformationDetail,
    removeEnvelopeDocument, removeEnvelopeRequestForm
} from "../../../../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../../../../utils";
import ManageDocument from "./ManageDocument";
import ManageForm from "./ManageForm";
import { Lang } from "../../../../../../lang";
// import "../../../../../../assets/ClientHome.css";

function EditRequest(props) {
    const [envelopeId, setEnvelopeId] = useState(0);
    const [documentList, setDocumentList] = useState([]);
    const [recipientsList, setRecipientsList] = useState([]);
    const [formList, setFormList] = useState([]);
    const [fromTemplate, setFromTemplate] = useState(1);
    const [isUseFromTemplate, setIsUseFromTemplate] = useState(false);

    useEffect(function () {
        setDocumentList(props.envelopeData.documents);
        setFormList(props.envelopeData.fill_forms);
        setRecipientsList(props.envelopeData.recipient_list);
        setEnvelopeId(props.envelopeData.id);
    }, [props.envelopeData]);

    const btnDocument = useRef(null);
    const btnRequestForm = useRef(null);
    const docDragItem = useRef();
    const docDragOverItem = useRef();
    const formDragItem = useRef();
    const formDragOverItem = useRef();

    const [docData, setDocData] = useState({
        id: 0,
        request_id: 0,
        doc_name: "",
        doc_detail: "",
        documents: [],
        date_format: 0
    });

    const [requestFormData, setRequestFormData] = useState({
        id: 0,
        request_id: 0,
        form_name: "",
        form_questions: []
    });

    const handleBackView = (e) => {
        e.preventDefault();
        props.setIsEditRequest(false);
        props.setIsRefresh(true);
    };

    const handleUseDocFormTemplate = (e, type) => {
        e.preventDefault();

        setFromTemplate(type);
        setIsUseFromTemplate(true);
    };

    const docDragStart = (e, position) => {
        docDragItem.current = position;
    };

    const docDragEnter = (e, position) => {
        docDragOverItem.current = position;
    };

    const docDrop = (e) => {
        const copyListItems = [...documentList];
        const dragItemContent = copyListItems[docDragItem.current];
        copyListItems.splice(docDragItem.current, 1);
        copyListItems.splice(docDragOverItem.current, 0, dragItemContent);
        docDragItem.current = null;
        docDragOverItem.current = null;
        setDocumentList(copyListItems);
    };

    const formDragStart = (e, position) => {
        formDragItem.current = position;
    };

    const formDragEnter = (e, position) => {
        formDragOverItem.current = position;
    };

    const formDrop = (e) => {
        const copyListItems = [...formList];
        const dragItemContent = copyListItems[formDragItem.current];
        copyListItems.splice(formDragItem.current, 1);
        copyListItems.splice(formDragOverItem.current, 0, dragItemContent);
        formDragItem.current = null;
        formDragOverItem.current = null;
        setFormList(copyListItems);
    };

    const onDocumentEdit = (e, data) => {
        e.preventDefault();
        props.setLoading(true);
        let obj = {
            id: data.id,
        };
        getEnvelopeDocumentDetail(obj)
            .then((response) => {
                let formData = { ...docData };
                formData.id = response.data.data.id;
                formData.request_id = response.data.data.request_id;
                formData.doc_name = response.data.data.doc_name;
                formData.doc_detail = response.data.data.doc_detail;
                let files = [];
                for (let i = 0; i < response.data.data.files.length; i++) {
                    files.push({
                        id: response.data.data.files[i]["id"],
                        name: response.data.data.files[i]["file_name"],
                        kb: response.data.data.files[i]["file_size"],
                        path: response.data.data.files[i]["file_path"],
                        file: "",
                    });
                }
                formData.documents = files;
                formData.date_format = response.data.data.date_format;
                setDocData(formData);
                btnDocument.current?.click();
                props.setLoading(false);
            })
            .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
                props.setLoading(false);
            });
    };

    const onDocumentClone = (e, data) => {
        e.preventDefault();
        props.setLoading(true);
        let obj = {
            id: data.id,
        };
        getEnvelopeDocumentDetail(obj)
            .then((response) => {
                let formData = { ...docData };
                formData.id = 0;
                formData.request_id = response.data.data.request_id;
                formData.doc_name = response.data.data.doc_name;
                formData.doc_detail = response.data.data.doc_detail;
                formData.documents = [];
                formData.date_format = response.data.data.date_format;
                setDocData(formData);
                btnDocument.current?.click();
                props.setLoading(false);
            })
            .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
                props.setLoading(false);
            });
    };

    const onDocumentDelete = (e, data) => {
        e.preventDefault();

        props.setLoading(true);
        let obj = {
            id: data.id,
        };
        removeEnvelopeDocument(obj)
            .then((response) => {
                let docList = [...documentList];
                let index = docList.findIndex((x) => parseInt(x.id) === parseInt(obj.id));
                docList.splice(index, 1);
                setDocumentList(docList);
                toast.success(response.data.message);
                props.setLoading(false);
            })
            .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
                props.setLoading(false);
            });
    };

    const onRequestFormEdit = (e, data) => {
        e.preventDefault();
        props.setLoading(true);
        let obj = {
            id: data.id,
        };
        getEnvelopeRequestInformationDetail(obj)
            .then((response) => {
                let formData = { ...requestFormData };
                formData.id = response.data.data.id;
                formData.request_id = response.data.data.request_id;
                formData.form_name = response.data.data.form_name;
                formData.form_questions = response.data.data.questions;
                setRequestFormData(formData);
                btnRequestForm.current?.click();
                props.setLoading(false);
            })
            .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
                props.setLoading(false);
            });
    };

    const onRequestClone = (e, data) => {
        e.preventDefault();
        props.setLoading(true);
        let obj = {
            id: data.id,
        };
        getEnvelopeRequestInformationDetail(obj)
            .then((response) => {
                let formData = { ...requestFormData };
                formData.id = 0;
                formData.request_id = response.data.data.request_id;
                formData.form_name = response.data.data.form_name;
                let questionList = response.data.data.questions;
                for (let i = 0; i < questionList.length; i++) {
                    questionList[i]['id'] = 0;
                    for (let j = 0; j < questionList[i]['options'].length; j++) {
                        questionList[i]['options'][j]['id'] = 0;
                    }
                }
                formData.form_questions = questionList;
                setRequestFormData(formData);
                btnRequestForm.current?.click();
                props.setLoading(false);
            })
            .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
                props.setLoading(false);
            });
    };

    const onRequestFormDelete = (e, data) => {
        e.preventDefault();

        props.setLoading(true);
        let obj = {
            id: data.id,
        };
        removeEnvelopeRequestForm(obj)
            .then((response) => {
                let fList = [...formList];
                let index = fList.findIndex((x) => parseInt(x.id) === parseInt(obj.id));
                fList.splice(index, 1);
                setFormList(fList);
                toast.success(response.data.message);
                props.setLoading(false);
            })
            .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
                props.setLoading(false);
            });
    };

    const handleEditSave = async (e) => {
        e.preventDefault();

        props.setLoading(true);

        let ipAddress = '';
        await Utils.getIpAddress().then(response => {
            ipAddress = response;
        });

        let obj = {
            id: envelopeId,
            document: documentList,
            request_form: formList,
            ip_address: ipAddress
        };

        editRequestUpdateDocumentForm(obj)
            .then(response => {
                toast.success(response.data.message);
                props.setLoading(false);
                props.setIsEditRequest(false);
                props.setIsRefresh(true);
            })
            .catch(err => {
                toast.error(Utils.getErrorMessage(err));
                props.setLoading(false);
            });

    };

    return (
        <div className="edit-request-container">
            <div className="edit-request-header">
                <h1>Edit Request</h1>
                <div className="tooltip-wrapper">
                    {/* <div className="tooltip-content">
                        Add Question into the Sleeves for which you required to collect Data.
                    </div> */}
                    <button
                        className="create-form-button"
                        data-bs-toggle="offcanvas"
                        data-toggle="tooltip"
                        title={Lang.env_add_question}
                        ref={btnRequestForm}
                        data-bs-target="#ManageRequestForm"
                    >
                        <i className="bi bi-plus"></i>
                        Create a Form
                    </button>
                </div>
            </div>

            <div className="edit-request-content">
                <h2 className="section-title">Information Request (Form Builder)</h2>

                <div className="form-items-list">
                    {formList && formList.map((item, index) => (
                        <div
                            key={index}
                            className="form-item"
                            draggable
                            onDragStart={(e) => formDragStart(e, index)}
                            onDragEnter={(e) => formDragEnter(e, index)}
                            onDragEnd={formDrop}
                        >
                            <div className="form-item-left">
                                <img src="/images/dots_rectangle.webp" alt="image4" className="me-3" />
                                <span>{item.name}</span>
                            </div>

                            <div className="form-item-right">
                                <div className="recipient-badges">
                                    {item.request_display.length === 0 ? (
                                        <div className="recipient-badge-everyone">
                                            <i className="bi bi-people"></i>
                                            Everyone
                                        </div>
                                    ) : (
                                        item.request_display.map((recipient, i) => (
                                            <div
                                                key={i}
                                                className="recipient-badge"
                                                title={recipient.full_name}
                                            >
                                                {recipient.display}
                                            </div>
                                        ))
                                    )}
                                </div>

                                <div className="action-buttons">
                                    <button
                                        onClick={(e) => onRequestFormEdit(e, item)}
                                        className="action-btn"
                                        data-toggle="tooltip"
                                        title="Edit"
                                    >
                                        <i className="bi bi-pencil"></i>
                                    </button>
                                    <button
                                        onClick={(e) => onRequestClone(e, item)}
                                        className="action-btn"
                                        data-toggle="tooltip"
                                        title="Clone"
                                    >
                                        <i className="bi bi-files"></i>
                                    </button>
                                    <button
                                        onClick={(e) => onRequestFormDelete(e, item)}
                                        className="action-btn-delete action-btn"
                                        data-toggle="tooltip"
                                        title="Delete"
                                    >
                                        <i className="bi bi-trash"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="footer-actions settings-actions">
                <button
                    type="button"
                    className="btn-back"
                    onClick={handleBackView}
                >
                    <i className="bi bi-arrow-left me-3"></i>
                    Back
                </button>
                <button
                    type="button"
                    onClick={handleEditSave}
                    className="btn-save"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z" />
                    </svg>
                    Save Settings
                </button>
            </div>

            <ManageDocument
                documentList={documentList}
                setDocumentList={setDocumentList}
                setLoading={props.setLoading}
                envelopeId={envelopeId}
                docData={docData}
                setDocData={setDocData}
                recipientsList={recipientsList}
            />

            <ManageForm
                formList={formList}
                setFormList={setFormList}
                setLoading={props.setLoading}
                envelopeId={envelopeId}
                requestFormData={requestFormData}
                setRequestFormData={setRequestFormData}
                recipientsList={recipientsList}
            />

            <RequestDocFormTemplate
                fromTemplate={fromTemplate}
                setFromTemplate={setFromTemplate}
                envelopeId={envelopeId}
                documentList={documentList}
                setDocumentList={setDocumentList}
                formList={formList}
                setFormList={setFormList}
                isUseFromTemplate={isUseFromTemplate}
                setIsUseFromTemplate={setIsUseFromTemplate}
            />
        </div >
    );
}

export default EditRequest;